var m = Object.freeze, O = Object.defineProperty;
var a = (i, e) => m(O(i, "raw", { value: m(e || i.slice()) }));
import { d as E } from "./exportparts-Bjal6DGN.js";
import { L as k } from "./lds-form-element-SiTAij9m.js";
import { i as C, x as d } from "./lit-element-CwWchyls.js";
import { n } from "./property-EvzlnPW3.js";
import { r as h } from "./state-D88UmDIj.js";
import { e as x } from "./query-Dk6NwgU8.js";
import { o as S } from "./query-assigned-elements-Wf_N7Qhp.js";
import { e as f } from "./class-map-CiBNip0q.js";
import "./lds-dropdown.js";
import "./lds-icon.js";
import { o as q } from "./if-defined-BopGAQiw.js";
import { e as z, a as I } from "./context-D-64zexR.js";
var v;
const L = C(v || (v = a(["\n    :host {\n        display: inline-block;\n        width: 100%;\n        position: relative;\n    }\n\n    lds-dropdown {\n        width: 100%;\n    }\n\n    .trigger {\n        border-color: transparent;\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n        border-radius: var(--lds-input-border-radius);\n        height: var(--lds-input-height-md);\n        background: var(--lds-color-default-20);\n        color: var(--lds-text);\n        font-weight: normal;\n        display: flex;\n        align-items: center;\n        padding: 0 var(--lds-spacing-md);\n        box-sizing: border-box;\n        position: relative;\n    }\n\n    .trigger.read-only {\n        opacity: 0.5;\n        cursor: text;\n    }\n\n    /** native select */\n    select {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        outline: none;\n        width: 100%;\n        border: none;\n        color: transparent;\n        right: 0;\n        appearance: none;\n        background: transparent;\n        cursor: pointer;\n    }\n\n    input:focus-visible ~ lds-dropdown .trigger {\n        outline: auto;\n    }\n\n    option {\n        color: var(--lds-text);\n    }\n\n    /** when device has hover hide the native select and show the options even if they should be hidden via mobile native */\n    @media (hover: hover) {\n        select {\n            display: none;\n        }\n    }\n\n    .options {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    label {\n        display: block;\n        font-weight: bold;\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        padding: 0;\n        margin: 0;\n        pointer-events: none;\n    }\n\n    .rotate-180 {\n        transform: rotateZ(180deg);\n    }\n\n    lds-icon {\n        margin-left: auto;\n    }\n\n    lds-dropdown::part(dropdown) {\n        width: max-content;\n        max-width: var(--dropdown-max-width);\n        min-width: 100%;\n        max-height: var(--lds-dropdown-max-height);\n    }\n\n    .has-error {\n        border-color: var(--lds-color-error);\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n    }\n\n    .error {\n        color: var(--lds-color-error);\n        font-size: var(--lds-font-size-xs);\n        line-height: var(--lds-font-size-sm);\n        padding-top: 4px;\n    }\n\n    .error-wrapper {\n        min-height: 18px;\n    }\n"])));
var P = Object.defineProperty, r = (i, e, o, l) => {
  for (var s = void 0, p = i.length - 1, u; p >= 0; p--)
    (u = i[p]) && (s = u(e, o, s) || s);
  return s && P(e, o, s), s;
}, g, b, w, y;
const c = class c extends k {
  constructor() {
    var e;
    super(...arguments), this.required = !1, this.value = "", this.label = "", this.ariaLabel = "", this.selectedOption = null, this.context = {
      setActive: (o, l = !0) => {
        this.value = o.value, this.selectedOption = o, this.context = { ...this.context, activeOption: o.uuid }, l && this.emit("change", { option: o });
      },
      activeOption: (e = this.selectedOption) == null ? void 0 : e.uuid
    }, this.readOnly = !1, this.open = !1;
  }
  get validationElement() {
    return this.input;
  }
  onDropdownChange(e) {
    if (this.readOnly) {
      e.target.open = !1;
      return;
    }
    this.open = e.detail;
  }
  firstUpdated() {
    this.addEventListener("click", (e) => {
      e.composedPath()[0] === this && this.dropdownElement.onClick();
    });
  }
  willUpdate(e) {
    if (e.has("value")) {
      const o = Array.from(this.options).find((l) => l.value === this.value);
      o && this.context.setActive(o, !1);
    }
  }
  onSlotChange() {
    this.options.forEach((e) => {
      e.selected && (this.emit("change", { option: e }), this.context.setActive(e, !1));
    });
  }
  onInputKeyDown(e) {
    e.key === "Enter" && this.click();
  }
  render() {
    var e;
    return d(y || (y = a(["\n            ", '\n            <input\n                autocomplete="off"\n                spellcheck="false"\n                autocapitalize="off"\n                tabindex="0"\n                aria-label=', "\n                aria-expanded=", '\n                role="combobox"\n                type="text"\n                ?required=', "\n                .value=", '\n                id="input"\n                readonly\n                aria-required=', "\n                @keydown=", ' />\n            <lds-dropdown\n                id="dropdown"\n                @change=', '\n                part="dropdown"\n                exportparts="', '">\n                <div\n                    class="trigger ', '"\n                    slot="trigger"\n                    part="trigger">\n                    <slot name="selected" part="selected">\n                        <span>', '</span>\n                    </slot>\n                    <lds-icon\n                        part="icon"\n                        name="chevron-down"\n                        class="', '"></lds-icon>\n                </div>\n                <div class="options" part="options">\n                    <slot @slotchange=', '></slot>\n                </div>\n            </lds-dropdown>\n            <div class="error-wrapper" part="error-wrapper">\n                ', "\n                ", "\n            </div>\n        "])), q(this.label) ? d(g || (g = a(['<label part="label" id="label" for="input">', "</label>"])), this.label) : "", this.ariaLabel, this.open ? "true" : "false", this.required, this.value, this.required, this.onInputKeyDown, this.onDropdownChange, E("dropdown"), f({ "has-error": this.hasError, "read-only": this.readOnly }), (e = this.selectedOption) == null ? void 0 : e.getTextLabel(), f({
      "rotate-180": this.open
    }), this.onSlotChange, this.currentValidationErrors.map((o) => d(b || (b = a(['<div class="error">', "</div>"])), o)), this.errors.map((o) => d(w || (w = a(['<div class="error">', "</div>"])), o)));
  }
};
c.styles = L;
let t = c;
r([
  n({ type: Boolean, reflect: !0 })
], t.prototype, "required");
r([
  n({ type: String })
], t.prototype, "value");
r([
  n({ type: String })
], t.prototype, "label");
r([
  n({ type: String, attribute: "aria-label" })
], t.prototype, "ariaLabel");
r([
  h()
], t.prototype, "selectedOption");
r([
  z({ context: I }),
  h()
], t.prototype, "context");
r([
  x("input")
], t.prototype, "input");
r([
  n({ type: Boolean, attribute: "read-only" })
], t.prototype, "readOnly");
r([
  h()
], t.prototype, "open");
r([
  S({ selector: "lds-option" })
], t.prototype, "options");
r([
  x("lds-dropdown")
], t.prototype, "dropdownElement");
const $ = new URL(import.meta.url), D = $.searchParams.has("debug");
if (!$.searchParams.has("no-define")) {
  const i = customElements.get("lds-select");
  i ? i.VERSION !== t.VERSION && D && console.log("%clds-select tried loading in version ".concat(t.VERSION, ", but lds-select is already defined as ").concat(i.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-select", t);
}
export {
  t as LdsSelect
};
